import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreBillingAgreementsModule,
  DatastoreCurrenciesIncludingExternalModule,
  DatastorePaymentShareMembersModule,
  DatastorePaymentShareMembersSpentAmountModule,
  DatastorePaymentShareTeamsModule,
} from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { PaymentShareMemberModalMemberTableComponent } from './payment-share-member-modal-member-table/payment-share-member-modal-member-table.component';
import { PaymentShareMemberModalComponent } from './payment-share-member-modal.component';

@NgModule({
  imports: [
    UiModule,
    TrackingModule,
    CommonModule,
    DatastoreCurrenciesIncludingExternalModule,
    DatastoreBillingAgreementsModule,
    DatastorePaymentShareTeamsModule,
    DatastorePaymentShareMembersModule,
    DatastorePaymentShareMembersSpentAmountModule,
    PipesModule,
  ],
  declarations: [
    PaymentShareMemberModalComponent,
    PaymentShareMemberModalMemberTableComponent,
  ],
})
export class PaymentShareMemberModalModule {}
